/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Orders_TitleInputs */

const en_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

const es_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos`)
};

const fr_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandes`)
};

const de_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen`)
};

const ja_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注文`)
};

const zh_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订单`)
};

const ar_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الطلبات`)
};

const id_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesanan`)
};

const it_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordini`)
};

const ru_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказы`)
};

const pt_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos`)
};

const ko_seller_orders_title = /** @type {(inputs: Seller_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주문 관리`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Seller_Orders_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_orders_title = /** @type {((inputs?: Seller_Orders_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Orders_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_orders_title(inputs)
	if (locale === "es") return es_seller_orders_title(inputs)
	if (locale === "fr") return fr_seller_orders_title(inputs)
	if (locale === "de") return de_seller_orders_title(inputs)
	if (locale === "ja") return ja_seller_orders_title(inputs)
	if (locale === "zh") return zh_seller_orders_title(inputs)
	if (locale === "ar") return ar_seller_orders_title(inputs)
	if (locale === "id") return id_seller_orders_title(inputs)
	if (locale === "it") return it_seller_orders_title(inputs)
	if (locale === "ru") return ru_seller_orders_title(inputs)
	if (locale === "pt") return pt_seller_orders_title(inputs)
	return ko_seller_orders_title(inputs)
});